/* ----- COMPONENT STYLES ---- 
    1. Example components styles below
*/
import styled from 'styled-components';
import { space, font, query } from '@design/templateFns';

export const Text = styled.p`
  ${font('body-sm')};
  padding: 30px;
  padding-bottom: ${space('md')};
  @media screen and (${query.atLeast('desktop')}) {
    ${font('body-md')};
  }
`;
